export default __webpack_public_path__ + "static/media/AtelierCombine.c393e992.png";